module.exports = __webpack_public_path__ + "img/tips6.9d1baa95.png";